import * as React from "react";
import { Icon } from "baseui/icon";
import { IconProps } from "baseui/icon";

// TODO: Could be a standard "svg as icon" function/component.

const DeleteCircle: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 26 26" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5822 22.9926C18.6573 22.9926 23.4575 18.0693 23.3037 11.9962C23.15 5.92297 18.1004 0.99968 12.0253 0.99968C5.95018 0.99968 1.14997 5.92297 1.30375 11.9962C1.45752 18.0693 6.50705 22.9926 12.5822 22.9926ZM12.6075 23.9923C19.2349 23.9923 24.4715 18.6214 24.3037 11.9962C24.136 5.37086 18.6274 0 12 0C5.37258 0 0.135993 5.37086 0.303749 11.9962C0.471504 18.6214 5.98008 23.9923 12.6075 23.9923Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.457 12.9572L15.9851 16.4853L16.6922 15.7782L13.1641 12.2501L16.4853 8.92893L15.7782 8.22183L12.457 11.543L8.91406 8L8.20696 8.70711L11.7499 12.2501L8 16L8.70711 16.7071L12.457 12.9572Z"
    />
  </Icon>
);

export default DeleteCircle;
